import { render, staticRenderFns } from "./BusinessDirectory.vue?vue&type=template&id=35d1af0a&"
import script from "./BusinessDirectory.vue?vue&type=script&lang=js&"
export * from "./BusinessDirectory.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDirectory.vue?vue&type=style&index=0&id=35d1af0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports